import gql from 'graphql-tag';

export default gql`
  query oosReasonTypes {
    oosReasonTypes {
      code
      nameVn
      nameEn
    }
  }
`;
